import '.n{width:100%;}.ssr-plugin'
import '.bd{padding-inline:1rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.a9{justify-content:center;}.ssr-plugin'
import '.b9{position:sticky;}.ssr-plugin'
import '.ba{top:0px;}.ssr-plugin'
import '.be{z-index:10;}.ssr-plugin'
import '.bc{background:var(--nav-bg);}.ssr-plugin'
import { type ReactNode } from 'react'
import { styled } from 'inlines'
import { TextLink } from '@app/components/core/link/TextLink'
import useTransform from '@app/util/useTransform'
import { pages } from '@app/util/links'
import { ResponsiveContainer } from '@app/components/layout/ResponsiveContainer'

export type NavBarDesktopProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
  logo: ReactNode
  children: ReactNode
}

export const NavBarDesktop = ({ logo, children }: NavBarDesktopProps) => {
  const transformStyle = useTransform('center')

  return (
    <nav className="n bd d a9 b9 ba be bc"
    >
      <ResponsiveContainer
        style={{
          background: 'var(--nav-bg)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          ...transformStyle,
        }}
      >
        <TextLink
          to={pages.home}
          noHover={true}
          isBold={false}
          textStyle={{ lineHeight: 0 }}
        >
          {logo}
        </TextLink>
        {children}
      </ResponsiveContainer>
    </nav>
  )
}
